import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import MaskedInput from 'react-text-mask';

const MaskInput = ({
  mask,
  type = 'other',
  fullWidth = true,
  error,
  className,
  onChange,
  ...rest
}) => {
  const extractDigits = (input) => input.replace(/\D/g, '');

  const handleChange = (e) => {
    const v = e.target.value;

    if (type === 'phone') {
      extractDigits(v).slice(0, 10);
      e.target.value = v;
    }

    onChange(e);
  };

  const phoneMask = () => [
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  const maskHandle = () => {
    switch (type) {
      case 'phone':
        return phoneMask();
      case 'zip':
        return [/\d/, /\d/, /\d/, /\d/, /\d/];
      default:
        return mask;
    }
  };

  const classes = clsx(
    'h-[44px] bg-legacy-white border-legacy-primary border rounded-[6px] text-[14px] sm:text-[16px] mx-[3px] mb-[8px] px-[12px] py-[4px]',
    'placeholder:text-legacy-placeholder',
    'focus:outline-none focus:border-legacy-focus focus:ring-[3px] focus:ring-legacy-focus/50',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'selection:bg-legacy-primary selection:text-white',
    fullWidth && 'w-[calc(100%-8px)]',
    error &&
      '!border-legacy-errorInput focus:border-legacy-errorInput focus:ring-legacy-errorInput/20',
    className,
  );

  return (
    <div className="relative">
      <MaskedInput
        mask={maskHandle}
        keepCharPositions={true}
        guide={true}
        showMask={true}
        placeholderChar={'_'}
        className={classes}
        onChange={handleChange}
        {...rest}
      />
    </div>
  );
};

MaskInput.propTypes = {
  mask: PropTypes.array,
  type: PropTypes.oneOf(['phone', 'zip', 'other']),
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
};

export default MaskInput;
